export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const SERVICE_KEY_DAILY_RATE = '-1';
export const SERVICE_KEY_HOURLY_RATE = '-2';
export const SERVICE_KEY_OPEN_ENDED = '-3';
export const SERVICE_KEY_PICKUP_ONLY = '-4';
